import {
  UPDATE_MIXTUREORDER_REQUEST,
  UPDATE_MIXTUREORDER_ERROR,
  UPDATE_MIXTUREORDER_SUCCESS,
  TOKEN_EXPIRED
} from '../types';
import context from "../common/updateEntity"
import RESOURCES from '../../api/resources';

const initialState = {};
export default (entity, entityTableData) => (state = initialState, action) => {

  context.init(context);

  context.UPDATE_ENTITY_REQUEST = UPDATE_MIXTUREORDER_REQUEST;
  context.UPDATE_ENTITY_ERROR = UPDATE_MIXTUREORDER_ERROR;
  context.UPDATE_ENTITY_SUCCESS = UPDATE_MIXTUREORDER_SUCCESS;
  context.TOKEN_EXPIRED = TOKEN_EXPIRED;

  context.entityName = "mixtureOrder";
  context.entityLocation = RESOURCES.MixtureOrders;

  return context.execute(context)(entity, entityTableData)(state, action);
};